module.exports = __webpack_public_path__ + "static/media/slider4img.2cbf2490.jpg";